// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"21e29def","571":"c0ed7bee","741":"c0f17d0a"}[chunkId] + ".chunk.css";
};